import { forwardRef } from "react";

import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

import { Button } from "@needl-ai/common/components/ui/button";
import { useSidebar } from "@needl-ai/common/components/ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@needl-ai/common/components/ui/tooltip";
import { cn } from "@needl-ai/common/lib/utils";

export const ToggleSidebarButton = forwardRef<
  HTMLButtonElement,
  ToggleSidebarButtonProps
>(({ className }, ref) => {
  const { state, toggleSidebar } = useSidebar();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={ref}
            variant="ghost"
            size="icon"
            className={cn(
              "p-2 hover:bg-gray-100 dark:hover:bg-neutral-800 text-neutral-500 dark:text-neutral-300 transition-all duration-200 [&_svg]:size-5",
              className
            )}
            aria-label="Toggle sidebar"
            onClick={toggleSidebar}
            data-testid="toggle-sidebar-button"
          >
            {state === "collapsed" ? <PanelLeftOpen /> : <PanelLeftClose />}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>{state === "collapsed" ? "Expand sidebar" : "Collapse sidebar"}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

ToggleSidebarButton.displayName = "ToggleSidebarButton";

type ToggleSidebarButtonProps = {
  className?: string;
};
